var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ItemBase } from '../../../models/item/item-base';
var LabelOperatorComponent = /** @class */ (function (_super) {
    __extends(LabelOperatorComponent, _super);
    function LabelOperatorComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cols = [];
        return _this;
    }
    LabelOperatorComponent.prototype.ngOnInit = function () {
        // super.ngOnInit();
    };
    LabelOperatorComponent.prototype.ngOnChanges = function (changes) {
        var operator = (this.col && this.col.params && this.col.params.operator ? this.col.params.operator : {});
        var type = this.col.controlType.replace(/Operator$/, '');
        var key = this.col.key;
        this.cols = [];
        if (this.col.controlType === 'textOperator') {
            this.cols.push(Object.assign(new ItemBase(), {
                key: key,
                controlType: type
            }));
            if (!operator || !operator.hidden) {
                this.cols.push(Object.assign(new ItemBase(), {
                    key: '$operator.' + key,
                    controlType: 'select',
                    params: {
                        options: [
                            { code: 'eq', display: this.msg['TextOperatorComponent.select.eq'] },
                            { code: 'like', display: this.msg['TextOperatorComponent.select.like'] },
                            { code: 'prefix', display: this.msg['TextOperatorComponent.select.prefix'] },
                            { code: 'suffix', display: this.msg['TextOperatorComponent.select.suffix'] }
                        ]
                    }
                }));
            }
        }
        else {
            if (this.val['$operator.$radio.' + key] === 'match') {
                this.cols.push(Object.assign(new ItemBase(), {
                    key: '$match.' + key,
                    controlType: type
                }));
            }
            else {
                this.cols.push(Object.assign(new ItemBase(), {
                    key: '$rangeFrom.' + key,
                    controlType: type
                }));
                if (typeof this.val['$rangeFrom.' + key] !== 'undefined' && this.val['$rangeFrom.' + key] !== null && this.val['$rangeFrom.' + key] !== '' && (!operator || !operator.rangeFrom || !operator.rangeFrom.hidden)) {
                    this.cols.push(Object.assign(new ItemBase(), {
                        key: '$operator.$rangeFrom.' + key,
                        controlType: 'select',
                        params: {
                            options: [
                                {
                                    code: 'ge',
                                    display: this.msg['RangeOperatorComponent.select.' + (type === 'number' ? type : 'datetime') + '.ge']
                                },
                                {
                                    code: 'gt',
                                    display: this.msg['RangeOperatorComponent.select.' + (type === 'number' ? type : 'datetime') + '.gt']
                                }
                            ]
                        }
                    }));
                }
                this.cols.push(Object.assign(new ItemBase(), {
                    label: '~',
                    controlType: 'label'
                }));
                this.cols.push(Object.assign(new ItemBase(), {
                    key: '$rangeTo.' + key,
                    controlType: type
                }));
                if (typeof this.val['$rangeTo.' + key] !== 'undefined' && this.val['$rangeTo.' + key] !== null && this.val['$rangeTo.' + key] !== '' && (!operator || !operator.rangeTo || !operator.rangeTo.hidden)) {
                    this.cols.push(Object.assign(new ItemBase(), {
                        key: '$operator.$rangeTo.' + key,
                        controlType: 'select',
                        params: {
                            options: [
                                {
                                    code: 'le',
                                    display: this.msg['RangeOperatorComponent.select.' + (type === 'number' ? type : 'datetime') + '.le']
                                },
                                {
                                    code: 'lt',
                                    display: this.msg['RangeOperatorComponent.select.' + (type === 'number' ? type : 'datetime') + '.lt']
                                }
                            ]
                        }
                    }));
                }
            }
        }
    };
    LabelOperatorComponent.prototype.trackByCol = function (index, col) {
        return JSON.stringify({ label: col.label, key: col.key });
    };
    LabelOperatorComponent.decorators = [
        { type: Component, args: [{
                    selector: 'column-label-operator',
                    template: "\n        <ng-template ngFor let-c [ngForOf]=\"cols\" [ngForTrackBy]=\"trackByCol\">\n            <column-formlabel [componentName]=\"componentName\" [index]=\"index\" [col]=\"c\" [val]=\"val[c.key]\" [msg]=\"msg\"></column-formlabel>\n        </ng-template>\n    ",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    LabelOperatorComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return LabelOperatorComponent;
}(ColumnBaseComponent));
export { LabelOperatorComponent };
//# sourceMappingURL=label-operator.component.js.map